export enum StringFilterConditions {
    Contains = 0,
    DoesNotContain = 1
}
